import { Box } from '@chakra-ui/react';

import useLoadRudderStack from './hooks/useLoadRudderStack';
import useTagManagerGate from './hooks/useTagManagerGate';
import Routes from './routes/Routes';

const App = () => {
  useLoadRudderStack();
  useTagManagerGate();

  return (
    <Box w="w-screen" overflowX="hidden">
      <Routes />
    </Box>
  );
};

export default App;
